import type { Atom, Unsubscribe } from '@exodus/atoms';
import type { Definition } from '@exodus/dependency-types';

import { EMBEDDABLE_SIGNER } from '@/ui/constants/index.js';
import type { Passkey } from './types.js';

type Dependencies = {
  passkey: Passkey;
  shareActivityAtom: Atom<boolean>;
};

const createShareActivityPlugin = ({
  passkey,
  shareActivityAtom,
}: Dependencies) => {
  let unobserveShareActivity: Unsubscribe | undefined;

  const onUnlock = () => {
    if (!EMBEDDABLE_SIGNER) {
      return;
    }

    unobserveShareActivity = shareActivityAtom.observe(
      async (shareActivity: boolean) => {
        passkey.shareActivity(shareActivity);
      },
    );
  };

  const onStop = () => {
    unobserveShareActivity?.();
  };

  return {
    onUnlock,
    onStop,
  };
};

const shareActivityPluginDefinition = {
  id: 'shareActivityPlugin',
  type: 'plugin',
  factory: createShareActivityPlugin,
  dependencies: ['shareActivityAtom', 'passkey'],
} as const satisfies Definition;

export default shareActivityPluginDefinition;
